
import { useParams } from 'react-router-dom';
import { PedidosHistorialFormState } from '../../../context/pedidoshistorial/PedidosHistorialFormState';
import { Form } from './form';

export const PedidosHistorialFormPage = () => {
  const { id } = useParams();
  const title = id ? "Ver Pedido":"Crear Pedidos";

  return (
    <PedidosHistorialFormState>
         <br />
        <Form title={title} />
    </PedidosHistorialFormState>
  );
};
